//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import fill from 'lodash/fill';
import map from 'lodash/map';
export default {
  name: 'MdmPagination',
  props: {
    pageSize: {
      type: Number,
      default: 40
    },
    total: {
      type: Number,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      show: ''
    };
  },

  computed: {
    pagination() {
      const a = fill(Array(Math.ceil(this.total / this.pageSize)), 1);
      return map(a, (x, y) => y + 1);
    }

  },

  mounted() {
    this.show = 'd-none';
  }

};